import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { findAnalysis } from "@/features/analytics/analyses";
import { CLASSIC_ANALYSIS_PAGES } from "@/features/analytics-classic/registry";

export const Route = createFileRoute("/analytics/classic/$slug")({
  component: ClassicAnalysisRoute,
});

/** The pre-redesign page, in its old layout, with a way to the new view. */
function ClassicAnalysisRoute() {
  const { slug } = Route.useParams();
  const analysis = findAnalysis(slug);
  const Page = analysis ? CLASSIC_ANALYSIS_PAGES[analysis.slug] : undefined;
  if (!analysis || !Page) {
    return (
      <div className="p-6 text-sm text-muted-foreground">
        There is no classic page for <code>{slug}</code>.
      </div>
    );
  }
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex shrink-0 items-center justify-between border-b border-olive-6 bg-olive-2 px-4 py-1.5 text-xs text-olive-10">
        <span>You are using the classic {analysis.name.toLowerCase()} page.</span>
        <Link
          to="/analytics/$slug"
          params={{ slug: analysis.slug }}
          className="flex items-center gap-1 font-medium text-olive-12 hover:underline"
        >
          Switch to the new view
          <ArrowRight className="size-3" />
        </Link>
      </div>
      <div className="container mx-auto h-full w-full max-w-[120rem] overflow-auto px-4 py-6">
        <Page />
      </div>
    </div>
  );
}
